/**
 * Returns true if the access token is expired or within `bufferMs` of expiring.
 * Default buffer is 5 minutes — refreshes start before the token actually expires
 * to avoid races where a request lands just after expiry.
 */
export function isMeshAccessTokenExpired(token, bufferMs = 5 * 60 * 1000) {
    return Date.now() >= token.expiresAt - bufferMs;
}
export function isMeshRefreshTokenExpired(token) {
    return Date.now() >= token.refreshTokenExpiresAt;
}
